import memoizeOne from 'memoize-one';
import type {WorkV4} from 'services/metadata/types';
import {selectMetadataEditSavedWorkSelector} from 'services/metadata';
import {useAppSelector} from 'store/hooks';
import {formatLinkedValueLink} from 'schema/preview/functions';

const getTitles = (
  agents: WorkV4['agents'] | undefined,
  preferredTitle: WorkV4['preferredTitle'] | undefined,
) => {
  const mainActor = agents?.[0];
  return {
    title: preferredTitle?.[0] ?? '',
    subtitle: mainActor?.link
      ? formatLinkedValueLink(mainActor.link)
      : undefined,
  };
};

const memoizedGetTitles = memoizeOne(getTitles);

export const useWorkTitles = (): {
  title: string;
  subtitle?: string;
} => {
  const work = useAppSelector(selectMetadataEditSavedWorkSelector);

  if (!work) {
    return {title: ''};
  }

  return memoizedGetTitles(work.agents, work.preferredTitle);
};
